import { createContext, useContext } from 'react';
import { toast as createCheckToast} from "react-fox-toast";
// Create the context
const ToastContext = createContext();

// Provider component
export const ToastProvider = ({ children }) => {
	
	const toast = (type, message) => {
		switch (type) {
			case "success":
				createCheckToast.success(message);
				break;
			case 'error':
				createCheckToast.error(message);
				break;
			case 'info':
				createCheckToast.info(message);
				break;
			case 'warning':
				createCheckToast.warning(message);
				break;
			default:
				createCheckToast.custom(message);
				break;
		}
	}

	return (
		<ToastContext.Provider value={{ toast }}>
			{children}
		</ToastContext.Provider>
	);
};

// Custom hook to use the toast context
export const useToast = () => {
	return useContext(ToastContext);
};